// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgDuplicateIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M17 21c0 .55-.45 1-1 1H6c-1.1 0-2-.9-2-2V7c0-.55.45-1 1-1s1 .45 1 1v13h10c.55 0 1 .45 1 1m1-19h-8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2" />
  </g>
);
export default SvgDuplicateIcon;
SvgDuplicateIcon.displayName = 'SvgDuplicateIcon';
